import React, { useEffect } from 'react';
import { pageTitle } from '../../helper';
import Cta from '../Cta';
import FunFact from '../FunFact';
import PageHeading from '../PageHeading';
import Div from '../Div';
import SectionHeading from '../SectionHeading';
import TeamSlider from '../Slider/TeamSlider';
import Spacing from '../Spacing';
import funfaceData from '../../data/funfaceData';

// const funfaceData = [
//   {
//     title: 'Global Happy Clients',
//     factNumber: '40K',
//   },
//   {
//     title: 'Project Completed',
//     factNumber: '50K',
//   },
//   {
//     title: 'Team Members',
//     factNumber: '245',
//   },
//   {
//     title: 'Digital products',
//     factNumber: '550',
//   },
// ];

export default function AboutPage() {
  pageTitle('About');

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <>
      {/* Start Page Heading Section */}
      <PageHeading
        title="About Us"
        bgSrc="images/about_hero_bg.jpeg"
        pageLinkText="About Us"
      />
      {/* End Page Heading Section */}

      {/* Start About Section */}
      <Spacing lg="150" md="80" />
      <Div className="container">
        <Div className="row">
          <Div className="col-xl-5 col-lg-7">
            <SectionHeading
              title="About Us"
              subtitle="Transform Your Business with Innovative Web3 Solutions"
            >
              <Spacing lg="30" md="20" />
              <p className="cs-m0">
                Welcome to DAppster Studio, where innovation meets creativity. We are a cutting-edge technology company specializing in delivering transformative digital solutions across various domains. From redefining user experiences to building immersive virtual environments, our team of experts is dedicated to turning your vision into reality.
              </p>
              <Spacing lg="30" md="30" />
              <Div className="cs-separator cs-accent_bg"></Div>
              <Spacing lg="25" md="40" />
            </SectionHeading>
          </Div>
          <Div className="col-lg-5 offset-xl-2">
            <img
              src="/images/about_img_1.jpeg"
              alt="About"
              className="w-100 cs-radius_15"
            />
            <Spacing lg="25" md="25" />
          </Div>
          <Div className="col-lg-7">
            <img
              src="/images/about_img_2.jpeg"
              alt="About"
              className="w-100 cs-radius_15"
            />
            <Spacing lg="25" md="25" />
          </Div>
          <Div className="col-lg-5">
            <img
              src="/images/about_img_3.jpeg"
              alt="About"
              className="w-100 cs-radius_15"
            />
            <Spacing lg="25" md="25" />
          </Div>
        </Div>
      </Div>
      <Spacing lg="75" md="55" />
      {/* End About Section */}

      {/* Start Fun Fact Section */}
      {/* <Div className="container">
        <FunFact
          title="Our fun fact"
          subtitle="Sed ut perspiciatis unde omnis iste natus error voluptatem accusantium doloremque laudantium, totam rem aperiam, eaque ipsa quae ab illo inventore veritatis."
          data={funfaceData}
        />
      </Div> */}
      {/* End Fun Fact Section */}

      {/* Start Why Choose Section */}
      <Spacing lg="100" md="80" />
      <Div className="container">
        <Div className="row">
          <Div className="col-xl-5 col-lg-6">
            <Div className="cs-image_layer cs-style1">
              <Div className="cs-image_layer_in">
                <img
                  src="/images/about_img_4.jpeg"
                  alt="About"
                  className="w-100 cs-radius_15"
                />
              </Div>
            </Div>
            <Spacing lg="0" md="40" />
          </Div>
          <Div className="col-xl-5 offset-xl-1 col-lg-6">
            <SectionHeading
              title="Expertise You Can Trust"
              subtitle="Why Choose Us"
            >
              <Spacing lg="30" md="20" />
              <p className="cs-m0">
                Our team brings years of experience in delivering cutting-edge solutions across industries. We specialize in leveraging the latest technologies to bring your ideas to life with precision and innovation.
              </p>
              <Spacing lg="15" md="15" />
              <p className="cs-m0">
                <strong>Client-Centric Approach:</strong> Your success is our priority. We work closely with you at every step, ensuring our solutions are tailored to your unique needs and exceed your expectations.
              </p>
              <Spacing lg="15" md="15" />
              <p className="cs-m0">
                <strong>End-to-End Solutions:</strong> From ideation to deployment, we offer comprehensive services to handle every aspect of your project. Our commitment to quality ensures that you receive a product that drives results and adds value.
              </p>
              <Spacing lg="30" md="30" />
              <Div className="cs-separator cs-accent_bg"></Div>
              <Spacing lg="25" md="0" />
            </SectionHeading>
          </Div>

        </Div>
      </Div>
      {/* End Why Choose Section */}

      {/* Start Team Section */}
      <Spacing lg="145" md="80" />
      {/* <Div className="container">
        <SectionHeading
          title="Awesome team <br/>members"
          subtitle="Our Team"
          variant="cs-style1"
        />
        <Spacing lg="85" md="45" />
        <TeamSlider />
      </Div> */}
      {/* End Team Section */}

      {/* Start CTA Section */}
      <Spacing lg="150" md="80" />
      <Div className="container">
          <Cta
            title="Let’s disscuse make <br />something <i>cool</i> together"
            btnText="Book a Call"
            btnLink="https://calendly.com/dappsterstudio/30min"
            btn2Text="Contact Us"
            btn2Link="/contact"
            bgSrc="/images/cta_bg.jpeg"
          />
      </Div>
      {/* End CTA Section */}
    </>
  );
}
